import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from "../pages/Dashboard";
import Login from "../pages/login/Login";
import Layout from "../layout/Layout";
import SectorPage from "../pages/admin/SectorActivit/SectorActivitPage";
import NotFound from '../pages/NotFound';
import VerifyEmail from '../pages/VerifyEmail';
import SignUpUser from '../pages/SignUpUser';
import ChangePassword from '../pages/ChangePassword';
import BusinesSizePage from '../pages/admin/BusinessSize/BusinessSizePage';
import NeighborhoodPage from '../pages/admin/Neighborhood/NeighborhoodPage';
import TypeBusinessPage from '../pages/admin/TypeBusiness/TypeBusinessPage';
import UsersPage from '../pages/admin/Users/UsersPage';
import FormsTemplatePage from "../pages/admin/FormsTemplate/FormsTemplatePage";
import EntrepreneurRegistration from '../pages/admin/Entrepreneur/EntrepreneurRegistration';
import EntrepreneurPage from '../pages/admin/Entrepreneur/EntrepreneurPage';
import DetailsEntrepreneur from '../pages/admin/Entrepreneur/DetailsEntrepreneur';
import { isTokenExpired, logout } from '../services/auth';
import FormsToRespond from '../pages/admin/Entrepreneur/FormsToRespond';
import ViewResponsesForm from '../pages/admin/FormsTemplate/ViewResponsesForm';
import ViewSpecificResponse from '../pages/admin/FormsTemplate/ViewSpecificResponse';
import GraficPage from '../pages/city_hall/GraficPage';
import FormBuilderPage from '../pages/admin/FormsTemplate/FormBuilderDialog';


const AppRoutes = ({ isAuthenticated, setAuthenticated }) => {
    const handleLogin = () => {
        setAuthenticated(true);
    };

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/*" element={<NotFound />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/login" element={!isAuthenticated ? <Login onLogin={handleLogin} /> : <Layout />} />
                <Route path="/signUp" element={<SignUpUser />} />
                <Route path="/verify-email" element={<VerifyEmail />} />

                {isTokenExpired() ? (
                    <>
                        {logout(setAuthenticated)}
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </>
                ) : (
                    <>
                        {/* Rotas do admin */}
                        <Route path="/admin" element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}>
                            <Route path="business-size" element={<BusinesSizePage />} />
                            <Route path="detailsEntrepreneur/:id" element={<DetailsEntrepreneur />} />
                            <Route path="entrepreneur" element={<EntrepreneurPage />} />
                            <Route path="entrepreneur-registration" element={<EntrepreneurRegistration />} />
                            <Route path="entrepreneur/edit/:id" element={<EntrepreneurRegistration />} />
                            <Route path="form-builder/:id" element={<FormBuilderPage />} />
                            <Route path="form-responses/response/:userId/:formId" element={<ViewSpecificResponse />} />
                            <Route path="forms-templates" element={<FormsTemplatePage />} />
                            <Route path="forms-view-responses/:id" element={<ViewResponsesForm />} />
                            <Route path="forms/edit/:id/:entrepreneur" element={<FormsToRespond />} />
                            <Route path="forms/response/:id/:entrepreneur" element={<FormsToRespond />} />
                            <Route path="neighborhood" element={<NeighborhoodPage />} />
                            <Route path="sector" element={<SectorPage />} />
                            <Route path="type-business" element={<TypeBusinessPage />} />
                            <Route path="users" element={<UsersPage />} />
                        </Route>

                        {/* Rotas da equipe técnica */}
                        <Route path="/team" element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}>
                            <Route path="detailsEntrepreneur/:id" element={<DetailsEntrepreneur />} />
                            <Route path="entrepreneur" element={<EntrepreneurPage />} />
                            <Route path="entrepreneur-registration" element={<EntrepreneurRegistration />} />
                            <Route path="entrepreneur/edit/:id" element={<EntrepreneurRegistration />} />
                            <Route path="forms/edit/:id/:entrepreneur" element={<FormsToRespond />} />
                            <Route path="forms/response/:id/:entrepreneur" element={<FormsToRespond />} />
                        </Route>

                        {/* Rotas da prefeitura */}
                        <Route path="/city_hall" element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}>
                            <Route path="business-size" element={<BusinesSizePage />} />
                            <Route path="detailsEntrepreneur/:id" element={<DetailsEntrepreneur />} />
                            <Route path="entrepreneur" element={<EntrepreneurPage />} />
                            <Route path="entrepreneur-registration" element={<EntrepreneurRegistration />} />
                            <Route path="entrepreneur/edit/:id" element={<EntrepreneurRegistration />} />
                            <Route path="form-responses/response/:userId/:formId" element={<ViewSpecificResponse />} />
                            <Route path="forms-templates" element={<FormsTemplatePage />} />
                            <Route path="forms-view-responses/:id" element={<ViewResponsesForm />} />
                            <Route path="forms/edit/:id/:entrepreneur" element={<FormsToRespond />} />
                            <Route path="forms/response/:id/:entrepreneur" element={<FormsToRespond />} />
                            <Route path="graphic-screen" element={<GraficPage />} />
                            <Route path="neighborhood" element={<NeighborhoodPage />} />
                            <Route path="sector" element={<SectorPage />} />
                            <Route path="type-business" element={<TypeBusinessPage />} />
                        </Route>
                    </>
                )}

                {/* Redirecionamento final para rotas inválidas */}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </BrowserRouter>

    );
};

export default AppRoutes;